import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {ExchangeDetail} from "../../../model/exchange/exchange-detail";
import {ExchangeBrokerCodeService} from "../../../services/exchange/exchange-broker-code.service";
import {BrokerCode} from "../../../model/exchange/broker-code";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-broker-code',
  templateUrl: './broker-code.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class BrokerCodeComponent extends CrudBaseComponent<BrokerCode> {

  //fields
  clearingHouses: FieldRecord<any>[]
  exchanges: FieldRecord<any>[]
  displayedExchangeCodes: FieldRecord<any>[]
  brokers: FieldRecord<any>[]

  constructor(cdref: ChangeDetectorRef,
              brokerCodeService: ExchangeBrokerCodeService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = brokerCodeService;
    this.newRecord = new BrokerCode();
    this.newRecord.exchangeCode = ExchangeDetail.ALL;
    this.prepareForClone = this.prepareRecordForClone;
  }

  prepareRecordForClone() {
    if (this.formRecord) {
      this.formRecord.id = -1;
    }
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'clearingHouse',
        width: 130
      },
      {
        field: 'exchangeCode',
        width: 150,
        mapId: record => !record.exchangeCode || record.exchangeCode === ExchangeDetail.ALL ? ExchangeDetail.ALL_TEXT : record.exchangeCode,
        icon: (record: any) => {
          const exchField = this.exchanges ? this.exchanges.find(field => field.value
            && field.value.code === record.exchangeCode) : undefined;
          if (exchField && exchField.value) {
            return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
          } else {
            return 'fas fa-globe-europe';
          }
        }
      },
      {
        field: 'broker',
        width: 100,
      },
      {
        field: 'code',
        width: 100,
      },
      {
        field: 'email',
      }];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'clearingHouse',
            required: true,
            filter: true,
            column: 6,
            type: TYPE.DROPDOWN,
            options: () => this.clearingHouses,
            changed: event => this.filterExchanges()
          },
          {
            field: 'exchangeCode',
            filter: true,
            column: 6,
            type: TYPE.DROPDOWN,
            options: () => this.displayedExchangeCodes,
            icon: (ig: any) => {
              const exchField = this.displayedExchangeCodes.find(field => field.value && field.value.code === ig);
              if (exchField && exchField.value) {
                return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
              } else {
                return 'fas fa-globe-europe';
              }
            },
            optionValue: 'id'
          },
          {
            field: 'broker',
            required: true,
            filter: true,
            column: 6,
            type: TYPE.DROPDOWN,
            options: () => this.brokers,
          },
          {
            field: 'code',
            required: true,
            column: 6,
            type: TYPE.TEXT
          },
          {
            field: 'email',
            column: 12,
            type: TYPE.EMAIL
          }]
      }];
  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;
    this.commonFieldService.getClearingHouses(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.clearingHouses = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 3;
    });

    this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.exchanges = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.filterExchanges();
      this.settingsFormLoadingProgressValue += 100 / 3;
    });

    this.commonFieldService.getBrokers(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.brokers = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 3;
    });

  }

  private filterExchanges() {
    let defaultAllExchange = FieldRecord.DEFAULT();
    defaultAllExchange.text = this.translateService.instant('page.account.form.defaultExchangeAll');
    defaultAllExchange.id = ExchangeDetail.ALL;
    if (this.exchanges && this.formRecord) {
      this.displayedExchangeCodes = this.exchanges.filter(field => this.formRecord.clearingHouse && field.value && this.formRecord.clearingHouse === field.value.clearingHouse);
      this.displayedExchangeCodes.unshift(defaultAllExchange);
      if (this.displayedExchangeCodes.filter(value => value.id === this.formRecord.exchangeCode).length == 0)
        this.formRecord.exchangeCode = ExchangeDetail.ALL;
    } else {
      this.displayedExchangeCodes = [defaultAllExchange];
    }
  }

  onFormShow() {
    this.filterExchanges();
  }
}
